document.addEventListener('DOMContentLoaded', () => {
  const uwb = new UWB({
    toolSmoothScroll: {
      reomveClasses: ['slideout'],
    }
  });
  
  if (window.matchMedia('(max-width: 768px)').matches) {
    const swiperMain = setSwiperMain();
  } else {
  }

  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.page_top', startFire);

  UWX.Waiting('.circle_01');
  UWX.Waiting('.circle_02');
  UWX.Waiting('.circle_03');
  UWX.Waiting('.circle_04');
  UWX.Waiting('.circle_05');

  UWX.MenuNth('.function-list li', '.function-item');

  UWX.ScrollActionReferPosition('.page_header', 100, {
    activeClass: 'slideout',
    sedationLine: -100,
    direction: 'down'
  });
  UWX.ScrollActionReferPosition('.page_header', 400, {
    activeClass: 'actived',
    sedationLine: 0,
    once: false,
    direction: 'both'
  });
});


const setSwiperMain = () => {
  return new Swiper('.sliderCase', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    loopAdditionalSlides: 1,
    navigation: {
      nextEl: '.swiper-next_btn',
      prevEl: '.swiper-prev_btn'
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    breakpoints: {
      321: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30
      },
    },
  });
}
